import { ConnectionType } from './schema/ConnectionType';
import { createStore } from 'satcheljs';
export var connectedAccountsStore = createStore('connectedAccountsStore', {
    accounts: [],
    selected: -1,
    isConnectedAccountsDirty: false,
    isDefaultFromDirty: false,
    accountsInfo: {
        SyncRequests: [],
    },
    connectGmailState: {
        isConnecting: false,
        displayName: '',
        isSendOnly: false,
        targetRootFolderEnabled: true,
    },
    editAccountState: {
        isSaving: false,
        displayName: '',
        emailAddress: '',
        isOAuthSync: false,
        isSendOnly: false,
        username: '',
        password: '',
        incomingServer: '',
        incomingPort: '',
        syncProtocol: 'None',
        outgoingServer: '',
        outgoingPort: '',
        incomingAuth: 'Basic',
        incomingSecurity: 'None',
        useAltUsernamePassword: false,
        altUsername: '',
        altPassword: '',
        leaveCopy: false,
        isErrorStatus: false,
    },
    dialogWindowState: {
        editAccountOpen: false,
        connectGmailOpen: false,
        connectBasicOpen: false,
        connectAdvancedOpen: false,
    },
    defaultFromState: {
        defaultFromAddress: '',
        emailAddresses: [],
        consumerMailboxOptions: {},
    },
    connectBasicState: {
        displayName: '',
        emailAddress: '',
        password: '',
        useNewFolder: true,
        isConnecting: false,
        advancedChecked: false,
    },
    connectAdvancedState: {
        displayName: '',
        emailAddress: '',
        username: '',
        password: '',
        useNewFolder: true,
        isConnecting: false,
        connectionType: ConnectionType.ImapSmtp,
        useAltUsernamePassword: false,
        imapServer: '',
        popServer: '',
        incomingPort: '',
        smtpServer: '',
        outgoingPort: '',
        incomingAuth: 'Basic',
        incomingSecurity: 'None',
        remoteSend: true,
        altUsername: '',
        altPassword: '',
        leaveCopy: true,
    },
});
//# sourceMappingURL=store.js.map